import React, { Component } from "react";

class Notification extends Component {
  state = { show: true };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ show: false });
    }, parseInt(this.props.duration) || 3000);
  }

  render() {
    if (!this.state.show) return null;

    const type = this.props.type || "success";

    // Styles
    const styles = {
      wrapper: {
        position: "fixed",
        top: "90px",
        right: "20px",
        width: "330px",
        display: "flex",
        alignItems: "center",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
        color: "#fff",
        zIndex: 9999,
        fontFamily: "Inter, sans-serif",
        transition: "all 0.3s ease-in-out",
        animation: "fadeIn 0.4s ease-out",
      },
      iconDiv: {
        width: "70px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "26px",
        color: "#fff",
      },
      contentDiv: {
        flex: 1,
        padding: "15px 18px",
        fontSize: "15px",
        fontWeight: "500",
        letterSpacing: "0.3px",
      },
      success: {
        background: "linear-gradient(135deg, #2ecc71, #27ae60)",
      },
      error: {
        background: "linear-gradient(135deg, #e74c3c, #c0392b)",
      },
      warning: {
        background: "linear-gradient(135deg, #f39c12, #e67e22)",
      },
    };

    const icons = {
      success: "fa-check-circle",
      error: "fa-times-circle",
      warning: "fa-exclamation-triangle",
    };

    const bgStyle = styles[type];
    const iconClass = icons[type];

    return (
      <div
        style={{
          ...styles.wrapper,
          ...bgStyle,
        }}
      >
        <div style={styles.iconDiv}>
          <i className={`fa ${iconClass}`}></i>
        </div>
        <div style={styles.contentDiv}>{this.props.title}</div>
      </div>
    );
  }
}

export default Notification;

// import React, { Component } from "react";

// class Notification extends Component {
//   state = {
//     show: true
//   };
//   componentDidMount() {
//     setTimeout(() => {
//       this.setState({
//         show: false
//       });
//     }, parseInt(this.props.duration));
//   }

//   render() {
//     if (this.state.show) {
//       return (
//         <div className="notDiv">
//           <span className="iconDiv">
//             <i className="fa fa-check"></i>
//           </span>
//           <span className="contentDiv">
//             <span className="title">{this.props.title}</span>
//           </span>
//         </div>
//       );
//     } else {
//       return null;
//     }
//   }
// }

// export default Notification;
